'use strict';

var reactIs = {exports: {}};

exports.__module = reactIs;
//# sourceMappingURL=index9.cjs.map
